import Carousel from "@mozaic-ds/freemarker/js/modules/_carousel.js";
const limitForVerticalDssDisplaySize = 1440;
function setVisibleAllDss(isLegacyPlp, maxElement) {
  const renderedDssContainer = document.querySelectorAll(".arm-dss-js-container");
  const renderedDssParentContainer = document.querySelectorAll(".arm-dss-content-sponsored");
  renderedDssContainer.forEach((dss, index) => {
    if (index < maxElement) {
      dss.classList.add("rendered");
      if (isLegacyPlp) dss.classList.add("legacy");
    } else {
      dss.classList.remove("rendered");
    }
  });
  renderedDssParentContainer.forEach(dss => {
    const container = dss.closest(".arm-dss-js-container");
    if (container && container.classList.contains("rendered")) {
      dss.classList.add("rendered");
    } else {
      dss.classList.remove("rendered");
    }
  });
}

/**
 * Reads the ACTUAL grid rows from the laid-out product list (by grouping
 * row-slot items that share the same vertical position) and returns them as
 * arrays, in DOM/top order.
 *
 * This is the visual source of truth used to place the DSS: instead of
 * computing an insertion index from "numberOfProducts x columns" (which breaks
 * whenever the category banner / breakzones / editorials shift product
 * indices), we anchor the DSS after the last product of a real, complete row.
 */
function getProductRows(parent) {
  if (!parent) return [];
  const products = Array.from(parent.children).filter(item => item.classList.contains("product-thumbnail"));
  if (products.length === 0) return [];

  // Force a layout flush so the bounding boxes read below are accurate,
  // even on resize/zoom or when Guidance injects products late.
  parent.offsetHeight;
  const firstRect = products[0].getBoundingClientRect();
  if (firstRect.height === 0) return [];
  const tolerance = Math.max(15, firstRect.height * 0.15);
  const rows = [];
  let currentRow = [products[0]];
  let rowTop = firstRect.top;
  for (let i = 1; i < products.length; i++) {
    const top = products[i].getBoundingClientRect().top;
    if (Math.abs(top - rowTop) <= tolerance) {
      currentRow.push(products[i]);
    } else {
      rows.push(currentRow);
      currentRow = [products[i]];
      rowTop = top;
    }
  }
  rows.push(currentRow);
  return rows;
}
function getCompleteProductRowSize(productRows) {
  return Math.max(...productRows.map(row => row.length));
}
function placeHorizontalMediaInsideCarousel(dssContentContainer, element) {
  let mediaDssElement = dssContentContainer.querySelector(".arm-container-media-dss");
  let ulElement = element.querySelector(".js-carousel-content");
  const containsInsideCarouselMedia = Array.from(ulElement.children).some(child => child.classList.contains("inside-carousel-media"));
  if (!containsInsideCarouselMedia) {
    const newLi = document.createElement("li");
    newLi.className = "inside-carousel-media";
    newLi.appendChild(mediaDssElement.cloneNode(true));
    mediaDssElement.remove();
    ulElement.insertBefore(newLi, ulElement.firstChild);
  }
}
function removeMediaFromInsideCarousel(carouselListElement, dss) {
  const insideCarouselMediaElement = carouselListElement.querySelector(".inside-carousel-media");
  const copy = insideCarouselMediaElement.cloneNode(true);
  let finalContainer = dss.querySelector(".arm-video-content");
  if (finalContainer.firstElementChild) finalContainer.insertBefore(copy.firstChild, finalContainer.firstElementChild);else finalContainer.appendChild(copy.firstChild);
  insideCarouselMediaElement.remove();
}
function resizeCarouselThumbnail(thumbnailsList, dssContainer, media, isMobile) {
  let maxWidthRatio = thumbnailsList.length > 2 ? 2.3 : thumbnailsList.length;
  const gapBetweenMediaAndCarousel = 16;
  const gapBetweenCarouselElements = 18;
  let gap = gapBetweenMediaAndCarousel + (thumbnailsList.length - 1) * gapBetweenCarouselElements;
  const minThumbnailWidth = 350;
  thumbnailsList.forEach(thumbnail => {
    let thumbnailWidth = (dssContainer.clientWidth - media.clientWidth - gap - gapBetweenMediaAndCarousel) / maxWidthRatio;
    thumbnail.style.minWidth = thumbnailWidth < minThumbnailWidth ? `${minThumbnailWidth}px` : `${thumbnailWidth}px`;
  });
  let container = dssContainer.querySelector(".container-carousel");
  if (!isMobile) {
    const delta = dssContainer.clientWidth - media.clientWidth - gapBetweenMediaAndCarousel;
    container.style.maxWidth = `${delta}px`;
  } else {
    container.style.maxWidth = "unset";
  }
}
function adjustWidth(mediaDss, width, maxThumbVisible, thumbnail, container, mediaSW) {
  mediaDss.style.width = `${mediaDss.clientHeight * 16 / 9}px`;
  width += (mediaSW - mediaDss.clientWidth) / maxThumbVisible;
  thumbnail.style.maxWidth = `${width}px`;
  container.style.minWidth = `${container.clientWidth + (mediaSW - mediaDss.clientWidth)}px`;
  return width;
}
function setSizeOfMediaComparedToThumbnail(isResized) {
  const dssToMove = isResized ? document.querySelectorAll(".arm-dss-js-container") : document.querySelectorAll(".arm-dss-content-sponsored");
  dssToMove.forEach(dss => {
    const dssContentContainer = dss.querySelector(".arm-video-content");
    const carouselContentList = dss.querySelectorAll(".arm-carousel-content");
    carouselContentList.forEach(async carousel => {
      const mediaDss = dssContentContainer.querySelector(".dss-media");
      const allThumbnail = carousel.querySelectorAll("li.product-thumbnail");
      const dssHeader = dss.querySelector(".arm-dss-header");
      const isVerticalDss = dssContentContainer.classList.contains("--vertical");
      const isHorizontalDss = dssContentContainer.classList.contains("--horizontal");
      const logoSize = 82;
      const minThumbnailWidth = 350;
      const gapBetweenCarouselElements = 18;
      const verticalPadding = 8;
      let dssHeaderHeight = window.innerWidth >= 1024 ? logoSize + verticalPadding : 0;
      const minHeightThumbnail = 200;
      const mobileBreakpointSize = 680;
      const dssTabletDisplayBreakpointSize = 1024;
      const isMobile = window.matchMedia(`(max-width: ${mobileBreakpointSize}px)`).matches;
      const isNoLogoHeader = dss.querySelector(".inside-carousel-header").classList.contains("no-logo");
      let maxHeight = 0;
      let container = dss.querySelector(".container-carousel");
      if (!isVerticalDss) {
        dssHeaderHeight = isNoLogoHeader ? dssHeaderHeight - 22 : dssHeaderHeight;
        if (allThumbnail.length > 0 && allThumbnail[0].clientHeight !== 0 && !isMobile) {
          mediaDss.style.maxWidth = `${minThumbnailWidth}px`;
          allThumbnail.forEach(thumbnail => {
            thumbnail.style.flex = `1 0 ${minThumbnailWidth}px`;
            thumbnail.style.maxWidth = `${minThumbnailWidth}px`;
            if (maxHeight === 0) maxHeight = thumbnail.clientHeight;
            thumbnail.style.maxHeight = "unset";
            mediaDss.style.maxHeight = `${maxHeight}px`;
            thumbnail.style.maxHeight = `${maxHeight}px`;
          });
          let mediaShouldHeight = allThumbnail[0].clientHeight + dssHeaderHeight;
          let mediaShouldWidth = mediaShouldHeight * 16 / 9;
          const gapBetweenMediaAndCarousel = 16;
          let emptySpace = isResized ? dss.clientWidth - mediaShouldWidth - 32 : dss.clientWidth - mediaShouldWidth - gapBetweenMediaAndCarousel;
          let maxThumbVisible = allThumbnail.length > 2 ? 2.5 : allThumbnail.length;
          let gap = (maxThumbVisible - 1) * 18;
          if (emptySpace > maxThumbVisible * minThumbnailWidth + gap) {
            initSizeMedia(mediaDss, container, mediaShouldWidth, mediaShouldHeight);
            container.style.minWidth = isResized ? `${emptySpace - gapBetweenMediaAndCarousel}px` : `${emptySpace}px`;
            container.style.maxWidth = maxThumbVisible !== 2.5 ? "unset" : isResized ? `${emptySpace - gapBetweenMediaAndCarousel}px` : `${emptySpace}px`;
            let width = (container.clientWidth - gap - gapBetweenMediaAndCarousel) / maxThumbVisible;
            let nbThumbs = allThumbnail.length - 1;
            let widthToFill = 0;
            allThumbnail.forEach((thumbnail, index) => {
              thumbnail.style.maxWidth = `${width}px`;
              if (window.innerWidth >= mobileBreakpointSize) {
                mediaDss.style.height = `${thumbnail.clientHeight + dssHeaderHeight}px`;
                if (index === nbThumbs) widthToFill = adjustWidth(mediaDss, width, maxThumbVisible, thumbnail, container, mediaShouldWidth);
              } else mediaDss.style.height = "unset";
              if (thumbnail.clientHeight < minHeightThumbnail) {
                widthToFill = adjustWidth(mediaDss, width, maxThumbVisible, thumbnail, container);
              }
            });
            allThumbnail.forEach(thumbnail => {
              thumbnail.style.maxWidth = `${widthToFill}px`;
            });
          } else if (emptySpace > minThumbnailWidth + gapBetweenCarouselElements) {
            initSizeMedia(mediaDss, container, mediaShouldWidth, mediaShouldHeight);
            container.style.maxWidth = `${emptySpace}px`;
            container.style.minWidth = "unset";
            allThumbnail.forEach(thumbnail => {
              thumbnail.style.maxWidth = `${minThumbnailWidth}px`;
            });
          } else {
            let gapBetweenItemCarousel = 18;
            let delta = minThumbnailWidth + gapBetweenCarouselElements - emptySpace;
            initSizeMedia(mediaDss, container, mediaShouldWidth - delta, (mediaShouldWidth - delta) * 9 / 16);
            container.style.maxWidth = `${minThumbnailWidth + gapBetweenItemCarousel}px`;
            container.style.minWidth = "unset";
            allThumbnail.forEach(thumbnail => {
              thumbnail.style.maxWidth = `${minThumbnailWidth}px`;
            });
          }
          if (window.innerWidth < dssTabletDisplayBreakpointSize) container.style.maxWidth = "unset";
        } else if (allThumbnail.length > 0 && allThumbnail[0].clientHeight !== 0) {
          container.style.maxWidth = "unset";
          container.style.minWidth = "unset";
          mediaDss.style.maxWidth = "unset";
          mediaDss.style.maxHeight = "unset";
          mediaDss.style.width = "100%";
          mediaDss.style.height = "100%";
        }
      } else if (!isHorizontalDss) {
        let elementToTarget = dss.parentElement.classList.contains("arm-dss-js-container") ? dss.parentElement : dss;
        if (window.innerWidth >= limitForVerticalDssDisplaySize) elementToTarget.classList.add("no-display-large-screen");else if (window.innerWidth >= 0 && window.innerWidth < limitForVerticalDssDisplaySize) elementToTarget.classList.remove("no-display-large-screen");
        const isNoLogoHeader = dss.querySelector(".inside-carousel-header").classList.contains("no-logo");
        const isMobileDss = dssHeader.classList.contains("outside-carousel-header") && dssHeader.clientHeight > 0;
        let offsetHeader = isNoLogoHeader ? 66 : logoSize + verticalPadding;
        resizeCarouselThumbnail(allThumbnail, dssContentContainer, mediaDss, isMobileDss);
        if (allThumbnail[0].clientHeight !== 0) {
          mediaDss.style.height = `${allThumbnail[0].clientHeight + offsetHeader}px`;
          mediaDss.style.width = `${mediaDss.clientHeight * 9 / 16}px`;
        }
        resizeCarouselThumbnail(allThumbnail, dssContentContainer, mediaDss, isMobileDss);
      }
    });
  });
}
function fallBackVerticalDss(maxAllowedDss, dssToMove) {
  const arr = Array.from(dssToMove);
  const isLargeScreen = window.innerWidth > limitForVerticalDssDisplaySize;
  if (!isLargeScreen) return arr;
  for (let i = 0; i < Math.min(maxAllowedDss, arr.length); i++) {
    const firstChild = arr[i].firstElementChild;
    if (firstChild && firstChild.classList.contains("--vertical")) {
      const swapIdx = arr.slice(i + 1).findIndex(el => el.firstElementChild && !el.firstElementChild.classList.contains("--vertical"));
      if (swapIdx !== -1) {
        const j = i + 1 + swapIdx;
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
    }
  }
  return arr;
}
function initSizeMedia(mediaDss, container, mediaShouldWidth, mediaShouldHeight) {
  mediaDss.style.width = `${mediaShouldWidth}px`;
  mediaDss.style.height = `${mediaShouldHeight}px`;
  mediaDss.style.maxWidth = "unset";
  mediaDss.style.maxHeight = "unset";
}
function positionDssFragmentsInProductsList(isResized, isLegacyPlp) {
  const width = window.innerWidth;
  const mobileBreakpointSize = 680;
  const legacyProductList = document.querySelector(".l-resultsList");
  const guidanceProductList = document.getElementById("guidance-product-list");
  const productList = legacyProductList || guidanceProductList;
  if (!legacyProductList) {
    isLegacyPlp = false;
  }
  const dssContents = Array.from(document.querySelectorAll(".arm-dss-content-sponsored"));
  document.querySelectorAll(".arm-dss-js-container").forEach(wrapper => wrapper.remove());
  const isMobile = window.matchMedia(`(max-width: ${mobileBreakpointSize}px)`).matches;
  let maxAllowedDss = isMobile ? 3 : 2;
  let placedDssCount = 0;
  const dssToMove = fallBackVerticalDss(maxAllowedDss, dssContents);
  const productRows = getProductRows(productList);
  if (productRows.length === 0) {
    setVisibleAllDss(isLegacyPlp, 0);
    return;
  }
  const completeProductRowSize = getCompleteProductRowSize(productRows);
  dssToMove.forEach((dss, index) => {
    let dssContentContainer = dss.querySelector(".arm-video-content");
    let carouselContent = dss.querySelectorAll(".arm-carousel-content");
    let oldContainerMedia = dss.querySelector(".rendered");
    carouselContent.forEach(element => {
      if (isMobile || width >= 1024) {
        if (width >= 1024 && !dssContentContainer.classList.contains("--vertical") && isLegacyPlp) dssContentContainer.classList.add("legacy");
        if (isMobile ? element.classList.contains("mobile-thumbnails") : !element.classList.contains("mobile-thumbnails")) {
          let carouselListElement = oldContainerMedia ? oldContainerMedia.querySelector(".js-carousel-content") : null;
          const containsInsideCarouselMedia = !carouselListElement ? false : Array.from(carouselListElement.children).some(child => child.classList.contains("inside-carousel-media"));
          if (containsInsideCarouselMedia) {
            removeMediaFromInsideCarousel(carouselListElement, dss);
          }
        }
      } else {
        carouselContent.forEach(element => {
          if (!element.classList.contains("mobile-thumbnails") && !element.classList.contains("--vertical")) {
            placeHorizontalMediaInsideCarousel(dssContentContainer, element);
          }
        });
      }
      if (element.classList.contains("mobile-thumbnails")) isMobile ? element.classList.add("rendered") : element.classList.remove("rendered");else isMobile ? element.classList.remove("rendered") : element.classList.add("rendered");
    });
    const targetRowNumber = isMobile ? index * 2 + 2 : index + 2;
    const targetRowIndex = targetRowNumber - 1;
    const targetRow = productRows[targetRowIndex];
    const anchor = targetRow && targetRow.length === completeProductRowSize ? targetRow[targetRow.length - 1] : null;

    // An incomplete target row must not render a DSS below it.
    if (!anchor) return;
    const container = document.createElement("li");
    container.classList.add("arm-dss-js-container");
    container.appendChild(dss);
    container.style.gridColumn = "1 / -1";
    anchor.after(container);
    placedDssCount++;
  });
  setVisibleAllDss(isLegacyPlp, placedDssCount < maxAllowedDss ? placedDssCount : maxAllowedDss);
}
function positionDssFragmentInPage(isResized, isLegacyPlp) {
  positionDssFragmentsInProductsList(isResized, isLegacyPlp);
  setSizeOfMediaComparedToThumbnail(isResized);
}
lm.DOMReady(() => {
  let isLegacyPlp = true;
  let parentList = document.getElementsByClassName("l-resultsList");
  parentList = Array.from(parentList);
  if (parentList.length === 0) {
    parentList.unshift(document.getElementById("guidance-product-list"));
    isLegacyPlp = false;
  }
  let resizeRafId = null;
  ["resize", "guidance:dom:updated"].forEach(event => {
    if (event === "resize") {
      window.addEventListener(event, () => {
        if (resizeRafId) {
          cancelAnimationFrame(resizeRafId);
        }
        resizeRafId = requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            positionDssFragmentInPage(true, isLegacyPlp);
            resizeRafId = null;
          });
        });
      });
    } else {
      window.addEventListener(event, () => positionDssFragmentInPage(true, isLegacyPlp));
    }
  });

  // Re-run placement whenever something that changes the row layout is
  // inserted into / removed from the product list: the category banner being
  // moved into the grid by its own script, breakzones, editorials, or
  // pagination. The DSS's own containers are explicitly ignored so moving
  // them does not loop. This makes the row-based placement self-correcting
  // regardless of the order in which the DSS and category-banner scripts run.
  const observedProductList = document.getElementById("guidance-product-list") || document.querySelector(".l-resultsList");
  if (observedProductList) {
    let scheduledLayoutPass = null;
    const scheduleDssReposition = () => {
      if (scheduledLayoutPass) return;
      scheduledLayoutPass = requestAnimationFrame(() => {
        scheduledLayoutPass = null;
        positionDssFragmentInPage(true, isLegacyPlp);
      });
    };
    const isInternalEndcapContainer = element => element.classList.contains("arm-dss-js-container") || element.classList.contains("push-collection-line-digital-endcap-container") || element.classList.contains("push-digital-endcap-container") || element.classList.contains("push-highlight-digital-endcap-container");
    const isRelevantLayoutElement = element => element.classList.contains("product-thumbnail") || element.id === "component-arm-category-banner" || element.classList.contains("l-resultsList__breakzone") || element.classList.contains("search_editorials-container");
    const isRelevantLayoutNode = node => {
      if (node.nodeType !== 1) return false;
      if (isInternalEndcapContainer(node)) return false;
      if (isRelevantLayoutElement(node)) return true;
      return false;
    };
    const layoutObserver = new MutationObserver(mutationsList => {
      const hasRelevantLayoutChange = mutationsList.some(mutation => {
        const changedElements = [...Array.from(mutation.addedNodes), ...Array.from(mutation.removedNodes)];
        if (changedElements.length === 0) return false;
        return changedElements.some(isRelevantLayoutNode);
      });
      if (!hasRelevantLayoutChange) return;
      scheduleDssReposition();
    });
    layoutObserver.observe(observedProductList, {
      childList: true,
      subtree: false
    });
  }
  positionDssFragmentInPage(false, isLegacyPlp);
  const carouselElements = document.querySelectorAll(".mc-carousel");
  carouselElements.forEach(e => {
    new Carousel(e);
  });
});